module.exports = __webpack_public_path__ + "src/assets/models/leaves/corn_leaf.fbx";